import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-E",
  "use": "icon-E-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-E\">\n<path d=\"M51.1446 15.064C50.4726 14.344 49.3686 14.344 48.6966 15.064L22.2966 41.416C21.9126 41.8 21.2406 41.8 20.8566 41.416L11.3046 31.912C10.6326 31.24 9.52856 31.24 8.85656 31.912C8.18456 32.584 8.18456 33.688 8.85656 34.36L18.4086 43.912C19.2246 44.728 20.3766 45.208 21.5766 45.208C22.7766 45.208 23.8806 44.728 24.7446 43.912L51.1446 17.512C51.8166 16.84 51.8166 15.736 51.1446 15.064Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol